// =====================================================================
// V4C Related chips (検索結果ページの検索窓直下に出す関連カテゴリ・ブランド)
// =====================================================================
//
// 役割:
//   /search ページの上部に「関連カテゴリ」「関連ブランド」の chip を出し、
//   それぞれの collection ページ (`/collections/<targetHandle>`) に遷移させる。
//
//   chip データは V4C completeQuery (= autocomplete) の結果を再利用する。
//   user-data dataset に投入済の brand / category suggestion が target_handle
//   付きで返るため、検索結果ページの「絞り込み」ではなく「コレクション遷移」
//   が成立する。
//
// 仕組み:
//   1. <v4c-related-chips data-query="..."> として section liquid から注入
//   2. connectedCallback で V4cClient.complete({query, limit: 16}) を 1 回叩く
//   3. type=brand / type=category の suggestion を、target_handle ありに絞って
//      最大 6 + 6 で chip 描画
//   4. クエリと完全一致する text も出す (例: q=gucci → GUCCI chip を出して
//      /collections/brands-gucci に遷移させる。検索結果ページと collection
//      ページは別物なので両方見たい需要がある)
//   5. 0 件なら hidden 維持
//
// マウント:
//   sections/v4c-search-results.liquid 内 (filter block / 商品 grid の上)
// =====================================================================

(function () {
  if (customElements.get('v4c-related-chips')) return;

  function escapeHtml(s) {
    if (typeof s !== 'string') return '';
    return s
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function readLocaleLabels(el) {
    return {
      categories: el.dataset.localeCategories || 'Related categories',
      brands: el.dataset.localeBrands || 'Related brands',
    };
  }

  // completion data の `text` には alias がそのまま入る (例: brands-gucci に対して
  // 「グッチ」「gucci」「GUCCI」が個別 entry で投入される) ので、ヒットした alias を
  // そのまま表示すると不揃いになる。section liquid 側で targetHandle → canonical
  // collection title (current locale で Translate & Adapt 翻訳済) を
  // window.V4cCollectionTitles に inject しているので、それを優先して表示する。
  function resolveDisplayText(c) {
    var map = window.V4cCollectionTitles;
    if (map && c.targetHandle && typeof map[c.targetHandle] === 'string') {
      return map[c.targetHandle];
    }
    return c.text || '';
  }

  function buildChipsRow(label, items) {
    if (!items || items.length === 0) return '';
    var chips = items
      .map(function (c) {
        var display = resolveDisplayText(c);
        var href = c.targetHandle
          ? '/collections/' + encodeURIComponent(c.targetHandle)
          : '/search?q=' + encodeURIComponent(display);
        return (
          '<a class="v4c-related-chip" href="' + href + '">' +
            escapeHtml(display) +
          '</a>'
        );
      })
      .join('');
    return (
      '<div class="v4c-related-row">' +
        '<span class="v4c-related-row__label">' + escapeHtml(label) + '</span>' +
        '<div class="v4c-related-row__chips">' + chips + '</div>' +
      '</div>'
    );
  }

  class V4cRelatedChips extends HTMLElement {
    connectedCallback() {
      var q = (this.dataset.query || '').trim();
      if (!q) {
        this.hidden = true;
        return;
      }
      if (!window.V4cClient || typeof window.V4cClient.complete !== 'function') {
        this.hidden = true;
        return;
      }
      this._fetchAndRender(q);
    }

    async _fetchAndRender(q) {
      try {
        var resp = await window.V4cClient.complete({ query: q, limit: 16 });
        var completions = (resp && resp.completions) || [];
        var brands = [];
        var categories = [];
        var seen = new Set();

        for (var i = 0; i < completions.length; i++) {
          var c = completions[i] || {};
          if (!c.text) continue;
          // collection ページに遷移できる brand / category のみ採用。
          // type=query (autocomplete の自由文 query) は targetHandle が null。
          if (!c.targetHandle) continue;
          // targetHandle 重複は除外 (例: 同じ brand の alias 違い)
          if (seen.has(c.targetHandle)) continue;
          seen.add(c.targetHandle);

          if (c.type === 'brand' && brands.length < 6) {
            brands.push(c);
          } else if (c.type === 'category' && categories.length < 6) {
            categories.push(c);
          }
        }

        if (brands.length === 0 && categories.length === 0) {
          this.hidden = true;
          return;
        }

        var labels = readLocaleLabels(this);
        this.innerHTML =
          buildChipsRow(labels.categories, categories) +
          buildChipsRow(labels.brands, brands);
        this.hidden = false;
      } catch (e) {
        console.warn('[v4c-related-chips] complete failed', e);
        this.hidden = true;
      }
    }
  }

  customElements.define('v4c-related-chips', V4cRelatedChips);
})();
